import { Review } from '../models/review';
import { JsEnv } from '../../../core/models/js_env';

export class ReviewAction {
  private static state: Review;
  static init(env: JsEnv, containerClass: any) {
    this.state = new Review(env.PAGE);
    return new containerClass(this.state.getModel());
  }
}
